import { Component, OnInit } from '@angular/core';
import { IMenus, IRoles } from 'src/app/interfaces/roles';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { RolesService } from 'src/app/services/roles/roles.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-view-mantenedor-menues-roles',
  templateUrl: './view-mantenedor-menues-roles.component.html',
  styleUrls: ['./view-mantenedor-menues-roles.component.scss']
})
export class ViewMantenedorMenuesRolesComponent implements OnInit{

  listaRoles: IRoles = {};
  listaMenus: any = [];
  rolSeleccionado: any = {
    id: 1,
    nombre: ""
  };

  mensajeExito: string = "";

  constructor(private serviciosRoles:RolesService,
    private _perfilamiento: PerfilamientoService,
    private router: Router
    ){

  }

  ngOnInit(): void {
    this.serviciosRoles.getRoles().subscribe (
      (result: IRoles) => {
        this.listaRoles.roles = result.roles;
        if (this.listaRoles.roles != undefined) {
          this.listaRoles.roles[0].seleccionado = true;
          this.rolSeleccionado.id = this.listaRoles.roles[0].id;
          this.rolSeleccionado.nombre = this.listaRoles.roles[0].nombre;
        }
      }
    );
    
    this.serviciosRoles.obtenerMenus(1).subscribe (
      (result:IMenus) => {
        result.modulos?.forEach((menu: any) => {
          let listaTmp = [];
          listaTmp[0] = {
            "nombre": menu.nombre,
            "id": menu.id,
            "seleccionado": false
          };
          let seleccionado = false;
          menu.menus.forEach((seccion: any) => {
            listaTmp.push({
              "nombre": seccion.nombre,
              "id": seccion.id,
              "seleccionado": seccion.seleccionado
            });
            if (seccion.seleccionado) {
              seleccionado = true;
            }
          });
          if(seleccionado) {
            listaTmp[0].seleccionado = true;
          }
          this.listaMenus.push(listaTmp);
        });
      }
    )
  }
  seleccionarRol(indice: number): void {
    this.rolSeleccionado.id = this.listaRoles.roles != undefined? this.listaRoles.roles[indice].id : 0;
    this.rolSeleccionado.nombre = this.listaRoles.roles != undefined? this.listaRoles.roles[indice].nombre : "";
    this.serviciosRoles.obtenerMenus( this.rolSeleccionado.id! ).subscribe (
      (result:IMenus) => {
        result.modulos?.forEach((menu: any, indexMenu: number) => {
          this.listaMenus[indexMenu][0].seleccionado = false;
          menu.menus.forEach((seccion: any, indexSeccion: number) => {
              this.listaMenus[indexMenu][indexSeccion+1].seleccionado = seccion.seleccionado;
          });
          let seleccionados = false;
          this.listaMenus[indexMenu].forEach((seccion: any) => {
            if (seccion.seleccionado) {
              seleccionados = true;
            }
          });
          if (seleccionados){
            this.listaMenus[indexMenu][0].seleccionado = true;
          }
        });
      }
    )
  }
  cambioMenuPrincipal(numeroMenu: number): void {
    for (let seccion = 1; seccion < this.listaMenus[numeroMenu].length; seccion++) {
      this.listaMenus[numeroMenu][seccion].seleccionado = this.listaMenus[numeroMenu][0].seleccionado;
    }
  }
  cambiarMenuPrincipal(indiceMenu: number, seccionSeleccionada: boolean): void {
    let seleccionados = false;
    for (let seccion = 1; seccion < this.listaMenus[indiceMenu].length; seccion++) {
      if (this.listaMenus[indiceMenu][seccion].seleccionado ){
        seleccionados = true;
      }
    }
    if (seleccionados) {
      this.listaMenus[indiceMenu][0].seleccionado = true;
    }else {
      this.listaMenus[indiceMenu][0].seleccionado = false;
    }
  }
  guardarCambios(): void {
    let menus: any = [];
    this.listaMenus.forEach((menu : any) => {
      for(let seccion = 1; seccion < menu.length; seccion++){
        if ( menu[seccion].seleccionado ) {
          menus.push({"menuId": menu[seccion].id});
        }
      }
    });
    let usuario = this._perfilamiento.getUsuario();
    let body = {
      "rolId": this.rolSeleccionado.id,
      "menus": menus,
      "auditoria": {
        "usuarioModificacion": usuario.username
      }
    }
    this.serviciosRoles.postRoles(body).subscribe(
      (response: any) => {
        this.mensajeExito = "Los cambios para el rol " + this.rolSeleccionado.nombre + " se realizaron de manera exitosa.";
        $('html, body').animate({

          scrollTop: 0

      }, 500);
      setTimeout(() => {
        this.mensajeExito = "";
      }, 5000);
      }
    )
  }
  volverInicio(): void {
    this.router.navigateByUrl('/view-inicio')  }
}
